module.exports = __webpack_public_path__ + "img/foguete.ce9c773b.png";